























import { Vue, Component } from "vue-property-decorator";
import ContractForm from "@/components/contract/ContractForm.vue";
import { Contract as IContract } from "@/api/models/contract";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CPage from "@/components/form/CustomPage/CPage.vue";

@Component({
  components: { CPage, ContractForm }
})
export default class ContractEdit extends Vue {
  contract!: IContract;
  data() {
    return {
      contract: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "contracts" },
        label: this.$tc(this.$translate.Contracts)
      },
      {
        to: { name: "contractItem", params: { contractId: this.contract.id } },
        label: this.contract.number
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  translateName(name: string) {
    if (name === "annex") {
      return `${this.$tc(this.$translate.ContractAddendum)} `;
    } else {
      return `${this.$tc(this.$translate.Contract)}`;
    }
  }

  mounted() {
    api.ContractApi.get(this.$route.params.contractId)
      .then((res: { data: IContract }) => {
        this.contract = res.data;
        document.title += ` ${this.contract.number}`;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }
}
